import AnchorLink from 'react-anchor-link-smooth-scroll'
import React from 'react'

class CtaComponent extends React.Component {
  render() {
    return (
      <div className="cta-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <p className="h1"><b>Interesse? </b>Lernen Sie uns kennen…</p>
              <p className="h3">
                Wir beraten Sie gerne <b>kostenfrei und unverbindlich</b> und freuen uns auf unser Kennenlerngespräch!
              </p>
            </div>
            <div className="col-md-4">
              <AnchorLink className="btn btn-primary btn-lg" href="#contact"><i className="far fa-comment-alt"></i> Kontaktieren Sie uns jetzt</AnchorLink>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CtaComponent



// WEBPACK FOOTER //
// ./src/components/CtaComponent/index.js